import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Header, List } from 'semantic-ui-react';

const DatasetStatusPopup = ({ reasons, status }) => (
  <>
    {reasons.length === 0 && (<FormattedMessage id={`dataset.${status}.yes.tooltip`} />)}
    {reasons.length > 0 && (
    <>
      <Header as="h6"><FormattedMessage id={`dataset.${status}.no.tooltip`} /></Header>
      <List bulleted items={reasons} />
    </>
    )}
  </>
);

export default DatasetStatusPopup;
